import React, { useEffect, useState } from "react";
import TableComponent from "../../../components/table";
import PaginationComponent from "../../../components/pagination";
import Api from "../../../services/api";
import { toast } from "react-toastify";
import LoadingComponent from "../../../components/loading";
import DateComponent from "../../../components/datepicker";
import CreativeTableContainer from "../../../components/CreativeTableContainer";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Tabs, DatePicker, Select, Input, Checkbox, Space, Row, Col, Tag, Button as AntButton } from "antd";
import { PlusOutlined, MinusOutlined, CloseOutlined } from "@ant-design/icons";
import Select2Custom from "../../../components/Select2Custom";
import { END_DATE, networkIcons, START_DATE } from "../../../utility";
import SelectAdnetworkComponent from "../../../components/selectAdnetwork";
import NoDataComponent from "../../../components/noData";

const { RangePicker } = DatePicker;

function CreativeCenter() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("over-view");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(
    moment().subtract(START_DATE, "days")
  );
  const [endDate, setEndDate] = useState(moment().subtract(END_DATE, "days"));
  const [adNetwork, setAdnetwork] = useState("");
  const [country, setCountry] = useState("");
  const [selectCountry, setSelectCountry] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [limit, setLimit] = useState(10);
  const { code, os } = useParams();

  // Creative Intel states
  const [creativeIntelStartDate, setCreativeIntelStartDate] = useState(moment().subtract(7, "days"));
  const [creativeIntelEndDate, setCreativeIntelEndDate] = useState(moment());
  const [useProbabilistic, setUseProbabilistic] = useState(false);
  const [filters, setFilters] = useState([
    { dimension: "", operator: "equals", value: "" },
    { dimension: "", operator: "between", minValue: "", maxValue: "" }
  ]);
  const [taggingSets, setTaggingSets] = useState([{ value: "" }]);
  const [groupByFeature, setGroupByFeature] = useState("");

  // Feature Tagging states
  const [features, setFeatures] = useState([
    {
      id: 1,
      name: "PERFORMANCE",
      tags: [
        { id: 1, name: "BEST", color: "#ff4d4f" },
        { id: 2, name: "LOW", color: "#722ed1" },
        { id: 3, name: "MEDIUM", color: "#52c41a" }
      ]
    },
    {
      id: 2,
      name: "Type",
      tags: [
        { id: 4, name: "playable", color: "#722ed1" },
        { id: 5, name: "AI", color: "#13c2c2" },
        { id: 6, name: "video", color: "#52c41a" },
        { id: 7, name: "banner", color: "#722ed1" }
      ]
    },
    {
      id: 3,
      name: "colour",
      tags: [
        { id: 8, name: "dark", color: "#722ed1" },
        { id: 9, name: "bright", color: "#eb2f96" }
      ]
    },
    {
      id: 4,
      name: "eng",
      tags: [
        { id: 10, name: "eng", color: "#52c41a" }
      ]
    },
    {
      id: 5,
      name: "sound",
      tags: [
        { id: 11, name: "loud", color: "#eb2f96" },
        { id: 12, name: "mute", color: "#52c41a" }
      ]
    }
  ]);
  const [newTagInputs, setNewTagInputs] = useState({});

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const tabParam = searchParams.get("tab");
    if (
      tabParam &&
      (tabParam === "over-view" ||
        tabParam === "creative" ||
        tabParam === "feature-tagging")
    ) {
      setActiveTab(tabParam);
    }
  }, []);

  const handleTabChange = (key) => {
    setActiveTab(key);
    navigate(`?tab=${key}`);
  };

  const handleChangeDate = (event, picker) => {
    setStartDate(picker.startDate);
    setEndDate(picker.endDate);
  };

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleSelectChangeAdNetwork = (item) => {
    setAdnetwork(item);
  };

  const handleSelectCountry = (item) => {
    setCountry(item);
  };

  const fetchData = (page = currentPage) => {
    setLoading(true);

    const adNetwork_filter = adNetwork ? adNetwork.target.value : "";
    const country_filter = country ? country.value : "";

    Api.get(`/api/app/creative_center`, {
      params: {
        os: os,
        code: code,
        ad_network: adNetwork_filter,
        country: country_filter,
        from: startDate.format("YYYY-MM-DD"),
        to: endDate.format("YYYY-MM-DD"),
        page: page,
        limit: limit,
      },
    })
      .then((result) => {
        if (result.data.code === 0) {
          const rawData = result.data.data;

          const generateDates = (start, end) => {
            const dates = [];
            let current = moment(start);
            while (current.isSameOrBefore(end, "day")) {
              dates.push(current.format("MMM DD, YYYY"));
              current = current.add(1, "day");
            }
            return dates;
          };

          const dates = generateDates(startDate, endDate);

          const convertedData = rawData.map((item) => {
            const convertToNumber = (value) => {
              if (typeof value === "string") {
                return parseFloat(value) || 0;
              }
              return value || 0;
            };

            return {
              name: item?.ad_name || item?.adset_name,
              percentage: convertToNumber(item.percentage),
              last_active: item.last_active || "N/A",
              dates: dates,
              chartData: dates.map((date) => {
                const key = moment(date, "MMM DD, YYYY").format("YYYY-MM-DD");
                return {
                  date: date,
                  dateKey: key,
                  impressions: convertToNumber(item.impressions?.[key]),
                  ipm: convertToNumber(item.ipm?.[key]),
                  ctr: convertToNumber(item.ctr?.[key]),
                  cti: convertToNumber(item.cti?.[key]),
                };
              }),
              network: item.network || null,
            };
          });

          setData(convertedData);
          setCurrentPage(result.data.page);
          setTotalPage(result.data.total_page);
          setTotalItems(result.data.total);
        } else {
          toast.error("Lỗi lấy dữ liệu !!");
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Lỗi lấy dữ liệu !!");
      });
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, code, os]);

  const handleRunReport = () => {
    setCurrentPage(1);
    fetchData(1);
  };

  // Creative Intel handlers
  const handleCreativeIntelDateChange = (dates) => {
    if (dates && dates.length === 2) {
      setCreativeIntelStartDate(dates[0]);
      setCreativeIntelEndDate(dates[1]);
    }
  };

  const handleFilterChange = (index, field, value) => {
    const newFilters = [...filters];
    newFilters[index][field] = value;
    setFilters(newFilters);
  };

  const addFilter = () => {
    setFilters([...filters, { dimension: "", operator: "equals", value: "" }]);
  };

  const removeFilter = (index) => {
    if (filters.length > 1) {
      const newFilters = filters.filter((_, i) => i !== index);
      setFilters(newFilters);
    }
  };

  const handleTaggingSetChange = (index, value) => {
    const newTaggingSets = [...taggingSets];
    newTaggingSets[index].value = value;
    setTaggingSets(newTaggingSets);
  };

  const addTaggingSet = () => {
    setTaggingSets([...taggingSets, { value: "" }]);
  };

  const removeTaggingSet = (index) => {
    if (taggingSets.length > 1) {
      const newTaggingSets = taggingSets.filter((_, i) => i !== index);
      setTaggingSets(newTaggingSets);
    }
  };

  const handleRunCreativeIntelReport = () => {
    // Logic để chạy Creative Intel report
    console.log("Running Creative Intel Report", {
      startDate: creativeIntelStartDate,
      endDate: creativeIntelEndDate,
      useProbabilistic,
      filters,
      taggingSets,
      groupByFeature
    });
  };

  // Feature Tagging handlers
  const handleFeatureNameChange = (featureId, newName) => {
    setFeatures(features.map(feature => 
      feature.id === featureId ? { ...feature, name: newName } : feature
    ));
  };

  const removeFeature = (featureId) => {
    setFeatures(features.filter(feature => feature.id !== featureId));
  };

  const addFeature = () => {
    const newId = Math.max(...features.map(f => f.id), 0) + 1;
    setFeatures([...features, { id: newId, name: "", tags: [] }]);
  };

  const removeTag = (featureId, tagId) => {
    setFeatures(features.map(feature => 
      feature.id === featureId 
        ? { ...feature, tags: feature.tags.filter(tag => tag.id !== tagId) }
        : feature
    ));
  };

  const addTag = (featureId, tagName) => {
    if (!tagName || !tagName.trim()) return;
    
    const colors = ["#ff4d4f", "#722ed1", "#52c41a", "#13c2c2", "#eb2f96", "#fa8c16", "#1890ff"];
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    const newTagId = Math.max(...features.flatMap(f => f.tags.map(t => t.id)), 0) + 1;
    
    setFeatures(features.map(feature => 
      feature.id === featureId 
        ? { ...feature, tags: [...feature.tags, { id: newTagId, name: tagName.trim(), color: randomColor }] }
        : feature
    ));
    
    // Clear the input
    setNewTagInputs({ ...newTagInputs, [featureId]: "" });
  };

  const handleNewTagInputChange = (featureId, value) => {
    setNewTagInputs({ ...newTagInputs, [featureId]: value });
  };

  const handleNewTagKeyPress = (e, featureId) => {
    if (e.key === 'Enter') {
      addTag(featureId, newTagInputs[featureId] || '');
    }
  };

  const saveFeatureTags = () => {
    console.log("Saving Feature Tags", features);
    // Logic để save features và tags
    toast.success("Feature Tags đã được lưu thành công!");
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await Api.get(
          `/api/app/dimension_filter?dimension=country`
        );
        if (response?.data?.data) {
          const options = Array.isArray(response.data.data)
            ? response.data.data
            : [];
          setSelectCountry(options);
        }
      } catch (error) {
        toast.error("Lỗi lấy dữ liệu !!");
      }
    };

    fetchCountries();
  }, []);

  return (
    <>
      <style>
        {`
                    .select__menu {
                        z-index: 9999 !important;
                    }
                    .select__menu-list {
                        z-index: 9999 !important;
                    }
                    .select__option {
                        z-index: 9999 !important;
                    }
                `}
      </style>
      <div className="background-second-dashboard">
        <div className="main__content-dashbard">
          <section className="container-fluid">
            <div className="card">
              <div className="card-body">
                <Tabs
                  type="card"  
                  activeKey={activeTab}
                  onChange={handleTabChange}
                  items={[
                    {
                      key: "over-view",
                      label: "Overview",
                      children: (
                        <div className="detail-body">
                          <div className="overview_content pd-20">
                            <div className="mt-4">
                              <div
                                className="filter d-flex"
                                style={{
                                  marginTop: "15px",
                                  marginBottom: "25px",
                                  position: "relative",
                                  // zIndex: 1000,
                                }}
                              >
                                <div
                                  className="me-2"
                                  style={{
                                    minWidth: "226px",
                                    position: "relative",
                                    zIndex: 1001,
                                  }}
                                >
                                  <div
                                    style={{
                                      position: "relative",
                                      zIndex: 1002,
                                    }}
                                  >
                                    <SelectAdnetworkComponent
                                      className="flex-fill"
                                      value={adNetwork}
                                      onChange={handleSelectChangeAdNetwork}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="me-2"
                                  style={{
                                    minWidth: "226px",
                                    position: "relative",
                                    zIndex: 1001,
                                  }}
                                >
                                  <div
                                    style={{
                                      position: "relative",
                                      zIndex: 1002,
                                    }}
                                  >
                                    <Select2Custom
                                      className="flex-fill"
                                      options={selectCountry}
                                      onChange={handleSelectCountry}
                                      placeholder="All countries"
                                      isMulti={false}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="me-2"
                                  style={{ minWidth: "300px" }}
                                >
                                  <DateComponent
                                    className="flex-fill"
                                    startDate={startDate}
                                    endDate={endDate}
                                    handleChangeDate={handleChangeDate}
                                  />
                                </div>
                                <div className="d-flex">
                                  <Button
                                    variant="primary"
                                    onClick={handleRunReport}
                                  >
                                    Run Report
                                  </Button>
                                </div>
                              </div>

                              <div className="mt-4">
                                <LoadingComponent loading={loading} />
                                <CreativeTableContainer
                                  data={data}
                                  loading={loading}
                                  networkIcons={networkIcons}
                                  currentPage={currentPage}
                                  totalPage={totalPage}
                                  handleChangePage={handleChangePage}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ),
                    },
                    {
                      key: "creative",
                      label: "Creative Intel",
                      children: (
                        <div className="detail-body">
                          <div className="overview_content pd-20">
                            <div className="mt-4">
                              <div style={{ maxWidth: "800px" }}>
                                {/* Date Range Section */}
                                <Row align="middle" style={{ marginBottom: "24px" }}>
                                  <Col span={6}>
                                    <label style={{ fontWeight: "500", color: "#333" }}>Date Range</label>
                                  </Col>
                                  <Col span={18}>
                                    <Space>
                                      <RangePicker
                                        ranges={{
                                          'This Week': [moment().startOf('week'), moment().endOf('week')],
                                          'Last Week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
                                          'This Month': [moment().startOf('month'), moment().endOf('month')],
                                          'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                          'Last 7 Days': [moment().subtract(7, 'days'), moment()],
                                          'Last 10 Days': [moment().subtract(10, 'days'), moment()],
                                          'Last 30 Days': [moment().subtract(30, 'days'), moment()],
                                        }}
                                        style={{ width: '100%' }}
                                      />
                                      <Checkbox
                                        checked={useProbabilistic}
                                        onChange={(e) => setUseProbabilistic(e.target.checked)}
                                        style={{ whiteSpace: "nowrap" }}
                                      >
                                        Use Probabilistic for Applovin
                                      </Checkbox>
                                    </Space>
                                  </Col>
                                </Row>

                                {/* Filters Section */}
                                <Row style={{ marginBottom: "24px" }}>
                                  <Col span={6}>
                                    <label style={{ fontWeight: "500", color: "#333" }}>Filters</label>
                                  </Col>
                                  <Col span={18}>
                                    <div>
                                      {filters.map((filter, index) => (
                                        <Row key={index} align="middle" style={{ marginBottom: "12px" }}>
                                          <Col span={6}>
                                            <Select
                                              placeholder="Select a dimension"
                                              value={filter.dimension}
                                              onChange={(value) => handleFilterChange(index, "dimension", value)}
                                              style={{ width: "100%" }}
                                              options={[
                                                { label: "Country", value: "country" },
                                                { label: "App", value: "app" },
                                                { label: "Network", value: "network" },
                                                { label: "Campaign", value: "campaign" }
                                              ]}
                                            />
                                          </Col>
                                          <Col span={4} style={{ paddingLeft: "8px" }}>
                                            <Select
                                              value={filter.operator}
                                              onChange={(value) => handleFilterChange(index, "operator", value)}
                                              style={{ width: "100%" }}
                                              options={[
                                                { label: "equals", value: "equals" },
                                                { label: "between", value: "between" },
                                                { label: "contains", value: "contains" }
                                              ]}
                                            />
                                          </Col>
                                          <Col span={8} style={{ paddingLeft: "8px" }}>
                                            {filter.operator === "between" ? (
                                              <Space>
                                                <Input
                                                  placeholder="Min"
                                                  value={filter.minValue}
                                                  onChange={(e) => handleFilterChange(index, "minValue", e.target.value)}
                                                  style={{ width: "80px" }}
                                                />
                                                <span>~</span>
                                                <Input
                                                  placeholder="Max"
                                                  value={filter.maxValue}
                                                  onChange={(e) => handleFilterChange(index, "maxValue", e.target.value)}
                                                  style={{ width: "80px" }}
                                                />
                                              </Space>
                                            ) : (
                                              <Input
                                                placeholder="Enter filters"
                                                value={filter.value}
                                                onChange={(e) => handleFilterChange(index, "value", e.target.value)}
                                                style={{ width: "100%" }}
                                              />
                                            )}
                                          </Col>
                                          <Col span={2} style={{ paddingLeft: "8px" }}>
                                            <Space>
                                              <AntButton
                                                type="dashed"
                                                icon={<MinusOutlined />}
                                                onClick={() => removeFilter(index)}
                                                disabled={filters.length === 1}
                                                style={{ 
                                                  color: "rgba(0, 0, 0, 0.88)",
                                                  border: "1px dashed #d9d9d9",
                                                  borderRadius: "50%",
                                                  minWidth: "32px",
                                                  height: "32px"
                                                }}
                                              />
                                              <AntButton
                                                type="dashed"
                                                icon={<PlusOutlined />}
                                                onClick={addFilter}
                                                style={{ 
                                                  color: "rgba(0, 0, 0, 0.88)",
                                                  border: "1px dashed #d9d9d9",
                                                  borderRadius: "50%",
                                                  minWidth: "32px",
                                                  height: "32px"
                                                }}
                                              />
                                            </Space>
                                          </Col>
                                        </Row>
                                      ))}
                                    </div>
                                  </Col>
                                </Row>

                                {/* Compare Tagging Sets Section */}
                                <Row style={{ marginBottom: "24px" }}>
                                  <Col span={6}>
                                    <label style={{ fontWeight: "500", color: "#333" }}>Compare Tagging Sets</label>
                                  </Col>
                                  <Col span={18}>
                                    <div>
                                      {taggingSets.map((set, index) => (
                                        <Row key={index} align="middle" style={{ marginBottom: "12px" }}>
                                          <Col span={4}>
                                            <label style={{ fontWeight: "500" }}>Set {index + 1}:</label>
                                          </Col>
                                          <Col span={16}>
                                            <Select
                                              placeholder="Please select"
                                              value={set.value}
                                              onChange={(value) => handleTaggingSetChange(index, value)}
                                              style={{ width: "100%" }}
                                              options={[
                                                { label: "Tagging Set 1", value: "set1" },
                                                { label: "Tagging Set 2", value: "set2" },
                                                { label: "Tagging Set 3", value: "set3" }
                                              ]}
                                            />
                                          </Col>
                                          <Col span={2} style={{ paddingLeft: "8px" }}>
                                            <AntButton
                                              type="dashed"
                                              icon={<MinusOutlined />}
                                              onClick={() => removeTaggingSet(index)}
                                              disabled={taggingSets.length === 1}
                                              style={{ 
                                                color: "rgba(0, 0, 0, 0.88)",
                                                border: "1px dashed #d9d9d9",
                                                borderRadius: "50%",
                                                minWidth: "32px",
                                                height: "32px"
                                              }}
                                            />
                                          </Col>
                                        </Row>
                                      ))}
                                      <AntButton
                                        type="dashed"
                                        icon={<PlusOutlined />}
                                        onClick={addTaggingSet}
                                        style={{ 
                                          marginTop: "8px",
                                          border: "1px dashed #d9d9d9",
                                          borderRadius: "6px",
                                          height: "32px",
                                          padding: "0 12px"
                                        }}
                                      >
                                        Add tagging set
                                      </AntButton>
                                    </div>
                                  </Col>
                                </Row>

                                {/* Group by Tagging Feature Section */}
                                <Row style={{ marginBottom: "24px" }}>
                                  <Col span={6}>
                                    <label style={{ fontWeight: "500", color: "#333" }}>Group by Tagging Feature</label>
                                  </Col>
                                  <Col span={18}>
                                    <Select
                                      placeholder="Select features"
                                      value={groupByFeature}
                                      onChange={setGroupByFeature}
                                      style={{ width: "100%" }}
                                      options={[
                                        { label: "Feature 1", value: "feature1" },
                                        { label: "Feature 2", value: "feature2" },
                                        { label: "Feature 3", value: "feature3" }
                                      ]}
                                    />
                                  </Col>
                                </Row>

                                {/* Run Report Button */}
                                <Row>
                                  <Col span={24}>
                                    <Button
                                      type="primary"
                                      size="large"
                                      onClick={handleRunCreativeIntelReport}
                                      style={{ 
                                        backgroundColor: "#1890ff",
                                        borderColor: "#1890ff",
                                        borderRadius: "6px",
                                        height: "40px",
                                        paddingLeft: "24px",
                                        paddingRight: "24px"
                                      }}
                                    >
                                      Run Report
                                    </Button>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </div>
                        </div>
                      ),
                    },
                    {
                      key: "feature-tagging",
                      label: "Feature Tagging",
                      children: (
                        <div className="detail-body">
                          <div className="overview_content pd-20">
                            <div className="mt-4">
                              <div style={{ maxWidth: "1000px" }}>
                                {/* Header */}
                                <div style={{ marginBottom: "24px" }}>
                                  <h3 style={{ 
                                    fontWeight: "bold", 
                                    fontSize: "18px", 
                                    color: "#333",
                                    margin: 0 
                                  }}>
                                    Feature Tags
                                  </h3>
                                </div>

                                {/* Feature List */}
                                <div style={{
                                  backgroundColor: "#f8f9fa",
                                  borderRadius: "8px",
                                  padding: "20px",
                                  border: "1px solid #e9ecef"
                                }}>
                                  {features.map((feature, index) => (
                                    <div key={feature.id} style={{ 
                                      marginBottom: index < features.length - 1 ? "20px" : "0",
                                      paddingBottom: index < features.length - 1 ? "20px" : "0",
                                      borderBottom: index < features.length - 1 ? "1px solid #e9ecef" : "none"
                                    }}>
                                      <Row align="middle" gutter={[16, 16]}>
                                        {/* Feature Column */}
                                        <Col span={6}>
                                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <AntButton
                                              type="dashed"
                                              icon={<MinusOutlined />}
                                              onClick={() => removeFeature(feature.id)}
                                              style={{ 
                                                color: "rgba(0, 0, 0, 0.88)",
                                                padding: "4px 8px",
                                                minWidth: "32px",
                                                height: "32px",
                                                borderRadius: "50%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                              }}
                                            />
                                            <Input
                                              value={feature.name}
                                              onChange={(e) => handleFeatureNameChange(feature.id, e.target.value)}
                                              placeholder="Feature name"
                                              style={{ 
                                                flex: 1,
                                                border: "1px solid #d9d9d9",
                                                borderRadius: "6px"
                                              }}
                                            />
                                          </div>
                                        </Col>

                                        {/* Tags Column */}
                                        <Col span={18}>
                                          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center" }}>
                                            {feature.tags.map((tag) => (
                                              <Tag
                                                key={tag.id}
                                                closable
                                                onClose={() => removeTag(feature.id, tag.id)}
                                                style={{
                                                  backgroundColor: tag.color,
                                                  color: "white",
                                                  border: "none",
                                                  borderRadius: "4px",
                                                  padding: "4px 8px",
                                                  fontSize: "12px",
                                                  fontWeight: "500"
                                                }}
                                                closeIcon={<CloseOutlined style={{ color: "white" }} />}
                                              >
                                                {tag.name}
                                              </Tag>
                                            ))}
                                            
                                            {/* New Tag Input */}
                                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                              <Input
                                                placeholder="New tag"
                                                value={newTagInputs[feature.id] || ""}
                                                onChange={(e) => handleNewTagInputChange(feature.id, e.target.value)}
                                                onKeyPress={(e) => handleNewTagKeyPress(e, feature.id)}
                                                onBlur={() => addTag(feature.id, newTagInputs[feature.id] || '')}
                                                style={{
                                                  width: "80px",
                                                  border: "1px dashed #d9d9d9",
                                                  borderRadius: "4px",
                                                  fontSize: "12px"
                                                }}
                                              />
                                              <AntButton
                                                type="dashed"
                                                size="small"
                                                onClick={() => addTag(feature.id, newTagInputs[feature.id] || '')}
                                                style={{
                                                  border: "1px dashed #d9d9d9",
                                                  borderRadius: "4px",
                                                  fontSize: "12px",
                                                  height: "24px",
                                                  padding: "0 8px"
                                                }}
                                              >
                                                + New Tag
                                              </AntButton>
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </div>
                                  ))}

                                  {/* Add Feature Button */}
                                  <div style={{ marginTop: "20px", paddingTop: "20px", borderTop: "1px solid #e9ecef" }}>
                                    <AntButton
                                      type="dashed"
                                      icon={<PlusOutlined />}
                                      onClick={addFeature}
                                      style={{
                                        border: "1px dashed #d9d9d9",
                                        borderRadius: "6px",
                                        height: "40px",
                                        padding: "0 16px",
                                        fontSize: "14px",
                                        fontWeight: "500"
                                      }}
                                    >
                                      Add Feature
                                    </AntButton>
                                  </div>
                                </div>

                                {/* Save Button */}
                                <div style={{ marginTop: "24px" }}>
                                  <AntButton
                                    type="primary"
                                    size="large"
                                    onClick={saveFeatureTags}
                                    style={{
                                      backgroundColor: "#1890ff",
                                      borderColor: "#1890ff",
                                      borderRadius: "6px",
                                      height: "40px",
                                      paddingLeft: "24px",
                                      paddingRight: "24px",
                                      fontSize: "14px",
                                      fontWeight: "500"
                                    }}
                                  >
                                    Save
                                  </AntButton>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ),
                    },
                  ]}
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default CreativeCenter;
